import React from 'react';
import { Button } from './ui/button';
import { Check, LogOut, Loader2, Play, Square } from 'lucide-react';

/**
 * Shared clock button components — single source of truth for all clock UI.
 * Used by: QuickClock.js, TimeClock.js, Kiosk.js (via QuickClock)
 *
 * Clock In  → green background, white text
 * Clock Out → blue background,  white text
 */

export function ClockInButton({ onClick, disabled, loading, size = 'default', className = '' }) {
  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      className={`w-full min-h-[48px] bg-green-600 hover:bg-green-700 active:bg-green-800 text-white font-semibold text-base rounded-lg transition-colors ${size === 'lg' ? 'text-xl py-8' : 'py-3'} ${className}`}
      data-testid="clock-in-btn"
    >
      {loading ? (
        <Loader2 className="h-5 w-5 animate-spin" />
      ) : size === 'lg' ? (
        <>
          <Play className="mr-3 h-6 w-6" fill="currentColor" />
          Clock In
        </>
      ) : (
        <>
          <Check className="mr-2" size={18} />
          Clock In
        </>
      )}
    </Button>
  );
}

export function ClockOutButton({ onClick, disabled, loading, size = 'default', className = '' }) {
  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      className={`w-full min-h-[48px] bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-semibold text-base rounded-lg transition-colors ${size === 'lg' ? 'text-xl py-8' : 'py-3'} ${className}`}
      data-testid="clock-out-btn"
    >
      {loading ? (
        <Loader2 className="h-5 w-5 animate-spin" />
      ) : size === 'lg' ? (
        <>
          <Square className="mr-3 h-6 w-6" fill="currentColor" />
          Clock Out
        </>
      ) : (
        <>
          <LogOut className="mr-2" size={18} />
          Clock Out
        </>
      )}
    </Button>
  );
}
